import * as enterView from 'enter-view';

enterView({
  selector: '.enter-view-container',
  offset: 0.9, // applies enter/exit to top of viewport
  enter: () => {
    // stick
    document
      .querySelector('.sticky-nav')
      .setAttribute('style', 'transform: translateY(0);');
  },
  exit: () => {
    // unstick
    document
      .querySelector('.sticky-nav')
      .removeAttribute('style', 'transform: translateY(0);');
  },
});
